import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import './ChecklistDeleteButton.less';

// todo make this button style a variation on IconButton in Zola-UI
const ChecklistDeleteButton = ({ taskId, deleteTask, label, className }) => (
  <button
    onClick={() => deleteTask(taskId)}
    className={cx({
      'checklist__button checklist__button--deleteTask': true,
      'checklist__button--large': Boolean(label),
      'button__icon--square': Boolean(!label),
      [className]: Boolean(className),
    })}
  >
    <i className="zola-ui-icon zola-ui-icon-trash checklist__deleteTask--icon" />
    {label}
  </button>
);

ChecklistDeleteButton.propTypes = {
  taskId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  deleteTask: PropTypes.func,
  label: PropTypes.string,
  className: PropTypes.string,
};

ChecklistDeleteButton.defaultProps = {};

export default ChecklistDeleteButton;



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistDeleteButton/ChecklistDeleteButton.jsx